/**
 * Session management configuration constants
 * Centralized timing configuration for chatbot session timeouts and refresh behavior
 *
 * Security Note: Guest timeout is intentionally shorter (5 min) to protect against
 * unauthorized access on shared/public computers. If a user walks away with the
 * chatbot minimized, cached messages expire quickly to prevent exposure.
 *
 * Signed-in timeout is longer (35 min) to align with Inbenta's token lifetime (~40 min)
 * and provide better UX for authenticated users.
 */
export const SESSION_CONFIG = {
  // Session timeout durations (in milliseconds)
  SIGNED_IN_TIMEOUT_MS: 35 * 60 * 1000, // 35 minutes (5 min before Inbenta's ~40 min token expiry)
  GUEST_TIMEOUT_MS: 5 * 60 * 1000, // 5 minutes for guest users (security requirement)

  // Warning timing
  WARNING_TIME_MS: 2 * 60 * 1000, // 2 minutes warning before timeout

  // Token refresh buffer
  REFRESH_BUFFER_MS: 30 * 1000, // 30 second buffer for token refresh
}
